import classNames from 'classnames';
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { useSelector } from 'react-redux'
import { selectFilterData } from '../mainFilter/selectors'
import TrustYouScore from '../dealsList/DealItemExperimental/TrustYouScore'
import NonCachedFooter from './NonCachedOffer/NonCachedFooter'
import cn from 'classnames'
import DealSlider from '../dealsList/DealItem/DealSlider'
import DealFlight from '../dealsList/DealItemExperimental/DealFlight'
import abTesting from '../../services/abTesting'

const NonCachedOffer = ({
  photos,
  hotelItem: hotel,
  dealItem,
  state,
  selected,
  nightsLabel,
  dateLabel,
  onPickDatesClick,
  hideSoldOutDeals,
  index,
}) => {
  const {
    searchEngine: { fromwhere: departures },
  } = useSelector(selectFilterData);

  const handleDealClick = () => {
    if (state === 'proposal') return

    if (!dealItem) {
      return false;
    }
    const { offer, hotel } = dealItem;
    let movsessid = '';
    if (window.location.search.indexOf('movsessid') > -1) {
      // Add movsessid to the offer URL (for analytics)
      const urlParams = new URLSearchParams(window.location.search);
      movsessid = `&movsessid=${urlParams.get('movsessid')}`;
    }
    window.open(
      offer.packageDeeplinkUrl.replace('/#/', `/?hotelId=${hotel.provider_hotel_id}${movsessid}/#/`),
      '_blank'
    );
    const time = Date.now();
    if (dealItem?.offer?.hfOfferId) {
      const offerTime = JSON.parse(localStorage.getItem('offerTime')) || {};
      offerTime[dealItem.offer.hfOfferId] = time;
      localStorage.setItem('offerTime', JSON.stringify(offerTime));
    }
  }

  const getHotelRating = () => {
    return Array.from({ length: hotel.rating }, (_, index) => (
      <i key={index} className="ri-star-fill" />
    ));
  };

  const cardClassName = cn('deal-item-experimental pb-10 col-lg-3 col-md-4 col-sm-6 deal-item-bswrap', {
    'deal-item-experimental--sold': ['sold', 'proposal'].includes(state),
  });

  const additionalAttr = {};
  if (typeof index !== 'undefined') {
    additionalAttr['data-position'] = index + 1;
  }
  if (dealItem && dealItem.offer) {
    additionalAttr['data-hfofferid'] = dealItem.offer.hfOfferId;
  }

  if (hideSoldOutDeals && state === 'sold') {
    return null
  }

  let flightElem = null;
  if (state === 'available' && dealItem) {
    const dealDeparture = departures.filter(dep => dep.id === dealItem.flight.city_from_airport_code);

    flightElem = (
      <DealFlight
        flight={dealItem.flight}
        nightFlight={dealItem?.offer?.stickers?.nightFlight}
        stickers={dealItem?.offer?.stickers}
        dealDeparture={dealDeparture}
      />
    )
  }

  return (
    <div className={cardClassName} {...additionalAttr}>
      <div className="rounded-xl shadow-lg relative cursor-pointer" onClick={handleDealClick}>
        <div className="gallery relative">
          <div className="slider overflow-hidden rounded-t-xl h-[200px]">
            <LazyLoadComponent threshold={200}>
              <DealSlider photos={photos} index={index} />
            </LazyLoadComponent>
          </div>
          <div className="absolute-fix absolute bottom-0 p-3 flex flex-col text-white text-start">
            <span className="heading-tiny leading-none !font-medium pb-1">{hotel.destinationData.atlas_top}</span>
            <span className="text-xl leading-none !font-bold pb-1">{hotel.destinationData.name}</span>
          </div>
        </div>
        <div className="m-details p-4">
          <div className="flex flex-col justify-center text-start">
            <div className={classNames("heading-small text-[14px]", { 'leading-4': !abTesting.flexibleDates, 'leading-5': abTesting.flexibleDates })}>
              {dateLabel} · {nightsLabel}
            </div>
          </div>
          <div className="hotel-highlight-txt pt-2 text-[12px] text-shark-500 font-medium">
            {hotel.packageHighlightOnCard}
          </div>
        </div>
        <div className="flex flex-col gap-4 p-4 min-h-[156px]">
          <div className="flex flex-col gap-3 min-h-[80px]">
            <div className="flex flex-col gap-1">
              <div className="deal-rating flex text-xs">
                {getHotelRating()}
              </div>
              <div className="hotel-name leading-5 label-large md:whitespace-nowrap text-ellipsis overflow-hidden text-start">{hotel.text}</div>
            </div>
            <TrustYouScore trustYouReviews={hotel.trustYouReviews} />
          </div>
          {flightElem}
        </div>

        <NonCachedFooter
          selected={selected}
          state={state}
          onPickDatesClick={onPickDatesClick}
          dealItem={dealItem}
        />
      </div>
    </div>
  )
}

export default NonCachedOffer
